import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import SetPasswordPagePreview from './SetPasswordPagePreview';
import type { ProductGroup } from '@app/core/models/client';

@Component({
  selector: 'set-password-page-preview-react',
  templateUrl: './set-password-page-preview-react-container.component.html',
  styleUrls: ['./set-password-page-preview-react-container.component.scss'],
  standalone: true,
})
export class SetPasswordPagePreviewReactContainerComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  constructor() {}

  reactWrapperId: string;
  @Input() pswMessageText: ProductGroup['password']['label'];
  @Input() pswButtonLabel: ProductGroup['password']['label'];
  @Input() pswTCS: ProductGroup['password']['tcs'];
  @Input() pswTCMandatory: ProductGroup['password']['tc_mandatory'];
  @Input() logoUrl: ProductGroup['branding']['icon_s3_url'];
  @Input() color: ProductGroup['branding']['color'];
  @Input() productGroupName: ProductGroup['name'];
  @Input() showProductGroup: ProductGroup['hide_pg_wire_display_name'];
  @Input() productGroupDescription: ProductGroup['description'];
  @Input() fdic: ProductGroup['fdic'];
  @Input() showFdic: boolean;
  @Input() language?: string;
  @Input() showLogo?: boolean;
  @Input() showTitleBar?: boolean;
  @Input() consentContent?: string;
  /** Renders the error state of the preview (PDF preview "error pages"). */
  @Input() isError?: boolean;
  /**
   * Product group es overrides (`i18n.es`), forwarded to the React preview so
   * the DS organism resolves customer-configured strings itself. Only the
   * PDF-preview path binds it; the config/translations editors leave it
   * undefined and keep driving the organism from live form values.
   */
  @Input() i18nEs?: NonNullable<ProductGroup['i18n']>['es'];

  root: Root = null;
  ngOnInit() {
    // Ids must be unique per instance: the PDF preview can mount the normal and
    // error previews side by side and the React root is found by id.
    this.reactWrapperId = this.isError
      ? 'set-password-page-preview-error'
      : 'set-password-page-preview';
  }

  ngOnDestroy(): void {
    this.root.unmount();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(SetPasswordPagePreview, {
          pswMessageText: this.pswMessageText,
          pswButtonLabel: this.pswButtonLabel,
          pswTCS: this.pswTCS,
          pswTCMandatory: this.pswTCMandatory,
          logoUrl: this.logoUrl,
          color: this.color,
          showProductGroup: this.showProductGroup,
          productGroupName: this.productGroupName,
          productGroupDescription: this.productGroupDescription,
          fdicSignage: this.fdic,
          showFdic: this.showFdic,
          language: this.language,
          showLogo: this.showLogo,
          showTitleBar: this.showTitleBar,
          consentContent: this.consentContent,
          isError: this.isError,
          i18nEs: this.i18nEs,
        }),
      );
    }
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }
}
